import React, { memo } from 'react'
import { Text } from 'react-native'
import { SuccessFailurePrompt } from '../../../../ui/molecules/SuccessFailurePrompt'
import { PromptSuccessIcon } from '../../../../assets/icons'
import { useTranslation } from 'react-i18next'

interface AddNewCreditCardFlow_SUCCESSProps {
  onSuccess: () => void
  isGuest?: boolean
}

export const AddNewCreditCardFlow_SUCCESS: React.FC<AddNewCreditCardFlow_SUCCESSProps> =
  memo(({ onSuccess, isGuest }) => {
    const { t } = useTranslation('global')
    return (
      <SuccessFailurePrompt
        visible
        exitable={false}
        onDismiss={onSuccess}
        contentContainerStyle={{ marginHorizontal: 40 }}
        title={`Card linked`}
        textContentBottomMargin={33}
        icon={<PromptSuccessIcon />}
        message={
          <Text testID={'add-new-credit-card-success-message'}>
            {isGuest
              ? t('integrations.modals.add-new-card.success-guest')
              : t('integrations.modals.add-new-card.success-common')}
          </Text>
        }
        modalStyle={{ justifyContent: 'center' }}
        buttonData={{
          title: 'Done',
          onPress: onSuccess,
          style: { width: 150 },
        }}
      />
    )
  })
